import { Component, Input } from '@angular/core';
import { PromotionHeader } from 'src/app/models/promotion-header.model';
import { CrudService } from 'src/app/services/crud.service';
import { environment } from 'src/environments/environment';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { PageOrientation } from 'pdfmake/interfaces';
import { PageSize } from 'pdfmake/interfaces';
import { GroupProductService } from '../../group-products-service.service';
import { Base64Images } from 'src/app/services/base64-images.service';
import { ReportStylesService } from 'src/app/services/report-styles.service';
import { LoadingService } from '../../report-loading.service';
import { DateService } from 'src/app/services/date.service';
import { FilterComponent } from '../../filter/filter.component';
import { DatePipe } from '@angular/common';

const pdf = pdfMake;
pdf.vfs = pdfFonts.vfs;


interface PromotionProduct {
  product_id: number;
  product_name: string;
  luc_ex_gst: { promotion_period_name: string; luc_ex_gst: number }[];
  buying: Record<string, string>;  // Assuming 'buying' is an object with dates as keys and string values
  promo: Record<string, string>;   // Same as above for 'promo'
  rebate: Record<string, string>;  // And for 'rebate'
}

interface GroupedPromotions {
  [category: string]: PromotionProduct[];
}

@Component({
    selector: 'app-buy-in-the-green',
    templateUrl: './buy-in-the-green.component.html',
    styleUrls: ['./buy-in-the-green.component.css'],
    providers: [ DateService, DatePipe ],
    imports: [ FilterComponent ],
    standalone: true
})


export class BuyInTheGreenComponent {

  @Input() name: string;
  @Input() reportComponent: string;
  private apiUrl: string = environment.baseApiUrl;
  data: any[];
  headers: PromotionHeader[];
  //promotionName: string = '';
  pageNumber: number = 1;
  userDetails: any;
  startdate:any;
  buying_group:any;
  disclaimer: string;
  constructor(private crudService: CrudService, private dateService:DateService, private base64Image: Base64Images, private reportStylesService:ReportStylesService,
    private loadingService: LoadingService,
    private groupedProductService: GroupProductService
  )
  {

    const userDetailsData = localStorage.getItem("userDetails");
    if (userDetailsData) {
      this.userDetails = JSON.parse(userDetailsData || '{}');

  } else {
      // Handle the null case, e.g., set to a default value or log an error
      this.userDetails = {}; // or some other default value
  }

    //
  }

  transformDataForPdfMake(groupedPromotions: any, promotionNamesMap: Record<string, string>): any[] {
    let bodyContent: any[] = [];
    const allPromotions: any = Object.values(groupedPromotions).flat();
    const uniqueDates = allPromotions.length > 0
      ? Array.from(new Set(allPromotions.flatMap((product: PromotionProduct) =>
          [...Object.keys(product.buying ?? {}), ...Object.keys(product.promo ?? {})]
        ))).sort()
      : [];

  if (uniqueDates.length > 0) {

    bodyContent.push([
      { text: 'Product Description', style:  {bold: true,
        fontSize: 10,
        color: 'white',
        fillColor: '#182351',
        alignment: 'center'} },
      ...uniqueDates.map((date: any) => {
    const day = new Date(date).getDate();
    const monthAbbr = new Date(date).toLocaleString('en-us', { month: 'short' }).toUpperCase();
    //const promotionPeriodName = firstPromotions.find((p: any) => p.promo[date]).promotion_period_name || '';
    const promotionPeriodName = promotionNamesMap[date] || '';
    return [
      { text: `${day}`, style: 'dayHeader' },
      { text: `${monthAbbr}`, style: 'monthHeader' },
      { text: `${promotionPeriodName}`, style: 'promoHeader' }
    ];
      })
    ]);
  }

    // Append all categories and products to the same table
    Object.entries(groupedPromotions).sort((a, b) => a[0].localeCompare(b[0])).forEach(([category, promotions]: any) => {
      // Category row within the table
      if(category == 'null'){
        category = 'Not Associated with a Category'
      }
      bodyContent.push([{
        border: [true, true, true, true], borderColor: ['white', 'white', 'white', 'white'],
        text: category,
        style: 'categoryHeader',
        colSpan: 1 + uniqueDates.length,
        alignment: 'left',
      }, ...Array(uniqueDates.length).fill('')]);
  
      promotions.sort((a: any, b: any) => a.product_name.localeCompare(b.product_name));
    
      // Construct rows for each product
      promotions.forEach((product: any) => {
        
        const dataCells = uniqueDates.map((date: any) => {
          const buyingValue = product.buying?.[date] || '0';
          const promoValue = product.promo?.[date] || '0';
          const rebateValue = product.rebate?.[date] || '0';
          const periodName = promotionNamesMap[date] || '';
          const tcMatch = periodName.match(/TC(\d+)/);
          const tcNum = tcMatch ? parseInt(tcMatch[1], 10) : null;
          const findLuc = (num: number | null) => {
            if (num == null || !Array.isArray(product.luc_ex_gst)) return null;
            return product.luc_ex_gst.find((e: any) => {
              const rangeMatch = e.promotion_period_name.match(/TC(\d+)\s*-\s*(?:TC)?(\d+)/);
              if (rangeMatch) {
                return num >= parseInt(rangeMatch[1], 10) && num <= parseInt(rangeMatch[2], 10);
              }
              const singleMatch = e.promotion_period_name.match(/TC(\d+)/);
              return singleMatch ? parseInt(singleMatch[1], 10) === num : false;
            }) ?? null;
          };
          let lucEntry = findLuc(tcNum);
          if (!lucEntry && tcNum != null && buyingValue !== '0' && promoValue === '0') {
            lucEntry = findLuc(tcNum + 1);
          }
          const lucPrice = lucEntry?.luc_ex_gst != null ? `$${lucEntry.luc_ex_gst.toFixed(2)}` : '';

          if (rebateValue !== '0') {
            return { border: [true, true, true, true], borderColor: ['white', 'white', 'white', 'white'], text: lucPrice, style: 'rebateStyle' };
          } else if (promoValue !== '0') {
            return {
              border: [true, true, true, true], borderColor: ['white', 'white', 'white', 'white'],
              fillColor: '#6edd60',
              stack: [
                {
                  columns: [
                    { text: '', width: '*' },
                    { canvas: [{ type: 'rect', x: 0, y: 0, w: 5, h: 5, color: '#182351' }], width: 6 }
                  ],
                  margin: [0, 0, 0, -3]
                },
                { text: lucPrice, fontSize: 10, alignment: 'center', color: '#313131' }
              ]
            };
          } else if (buyingValue !== '0') {
            return { border: [true, true, true, true], borderColor: ['white', 'white', 'white', 'white'], text: lucPrice, style: 'promoStyle' };
          } else {
            return { border: [true, true, true, true], borderColor: ['white', 'white', 'white', 'white'], text: '', style: 'buyinGreenEmptyCell' };
          }
        });

        bodyContent.push([
          { text: product.product_name, style: 'bodyStyle' },
          ...dataCells
        ]);
      });
    });
    const subheader = {
      stack: [
        {
          columns: [
            {
              text: `${this.name}`,
              style: 'header',
              alignment: 'left',
            },
            {
              image: this.base64Image.getBase64Image(this.userDetails.data.location_token),
              width: 150,
              alignment: 'right',
              margin: [0, 0, 0, 0]
            }
          ]
        }
      ]
    };

    const secondHeader = {
      stack: [
        {
          columns: [
            {
              text: `All Suppliers`,
              alignment: 'left'
            },
            {
              text: `${this.buying_group}`,
              alignment: 'center'
            },
            {
              text: `From: ${this.startdate}`,
              style: 'subheader',
              alignment: 'right',
              margin: [0, 0, 35, 0]
            }
          ]
        }
      ]
    };
    const legend = {
      columns: [
        { text: 'Legend:', bold: true, width: 'auto', margin: [0, 5, 10, 0], fontSize: 8 },
        { canvas: [{ type: 'rect', x: 0, y: 5, w: 15, h: 12, color: '#6edd60' }], width: 20 },
        { text: 'Promotion (LUC price shown)', width: 'auto', margin: [5, 5, 20, 0], fontSize: 8 },
        { canvas: [{ type: 'rect', x: 0, y: 5, w: 15, h: 12, color: '#e76969' }], width: 20 },
        { text: 'Hump Buster', width: 'auto', margin: [5, 5, 0, 0], fontSize: 8 }
      ],
      margin: [0, 10, 0, 0]
    };

    // Define the whole content as a single table section
    return [
      subheader,
      secondHeader,
      {
        table: {
          headerRows: 1,
          widths: ['auto', ...Array(uniqueDates.length).fill('*')],
          body: bodyContent
        },
        layout: {
          defaultBorder: false,
          hLineWidth: () => 0.1,
          vLineWidth: () => 0.1,
          fillColor: (rowIndex: number) => {
            if (rowIndex === 0) {
              return '#182351';
            }
            if (rowIndex % 2 === 0 && rowIndex !== 0) {
              return '#d9f0f1';
            }
            return null;
          }
        }
      },
      legend
    ];
  }


  pdfCreator(promotions: any, promotionNamesMap: Record<string, string>) {
    const transformedDataArray = this.transformDataForPdfMake(promotions, promotionNamesMap);
    const styles: any = this.reportStylesService.getStyles();

    const documentDefinition = {
      content: [...transformedDataArray],
      pageOrientation: 'portrait' as PageOrientation,
      pageSize: 'A4' as PageSize,
      styles: styles,
      border: [false,false,false,false],
      info: {
        title: `Buy In The Green ${this.startdate}`,
      },
      footer: (currentPage: number, pageCount: number) => {
        return {

          stack: [
            {
              columns: [
                {
                  text: `${this.disclaimer}`,
                  style: 'footerDisclaimer',
                  fontSize:6
                },
               
                {
                  text: `Promoflo © 2024 OnTap Data Inc. \n
                  Created: ${this.dateService.getCurrentDateTime()} \n
                  Page ${currentPage} of ${pageCount}`,
                  style: 'copyrightFooter',
                  fontSize:6

                }
              ]
            }
            ]
        };
    }
    };

    const filename = `BuyInGreen_${new Date().toDateString()}.pdf`;
    pdfMake.createPdf(documentDefinition).download(filename);
    this.loadingService.toggleLoading(false);
    this.sortedUniqueDates = [];
  }


sortedUniqueDates:any = [];
getPromoData(e: any): void {
  this.buying_group = e.buyingGroupFiltered.buying_group_name;
  const buyingGroupId = e.buyingGroupFiltered.id;
  this.startdate = e.buyInGreenDateSelected;
  const weeks = e.weeksCount;
  this.disclaimer = e.disclaimer;
 // Promotion Periods API URL
 const promoPeriodsUrl = `${this.apiUrl}promotion-periods?start_date=${e.buyInGreenDateSelected}&number_of_weeks=${weeks}`;

 // Fetch both datasets concurrently
 Promise.all([
  this.crudService.getData(promoPeriodsUrl).toPromise(),
  this.crudService.getData(`${this.apiUrl}buy-in-green?buying_group_id=${buyingGroupId}&start_date=${e.buyInGreenDateSelected}&weeks=${weeks}`).toPromise()
]).then(([promoPeriodsData, buyingGreenData]) => {
  const promoNamesMap = this.createPromoNamesMap(promoPeriodsData);
  const groupedData = this.groupDataByCategory(buyingGreenData, promoNamesMap);

  this.pdfCreator(groupedData, promoNamesMap);
}).catch((error: Error) => {
  console.error('Error fetching data:', error);
});
}

createPromoNamesMap(promoPeriodsData: any[]): Record<string, string> {
  let map: Record<string, string> = {};
  promoPeriodsData.forEach(promo => {
    let startDate = new Date(promo.start_date);
    let endDate = new Date(promo.end_date);
    for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
      let formattedDate = date.toISOString().split('T')[0]; // Format date as 'YYYY-MM-DD'
      map[formattedDate] = promo.promotion_name;
    }
  });
  return map;
}



groupDataByCategory(buyingGreenData: any[], promoNamesMap: Record<string, string>): any {
  return buyingGreenData.reduce((acc, obj) => {
    const key = obj.planning_category_name;
    if (!acc[key]) {
      acc[key] = [];
    }
    // Include promotion name from the mapped data
    const promoName = promoNamesMap[obj.start_date];
    obj.promotion_name = 'test'//promoName;
    acc[key].push(obj);
    return acc;
  }, {});
}
@Input() selectedFilter: string = '';
handleSelectedFilter(filter: string) {
  this.selectedFilter = filter;
  }

}

